import { useCallback } from 'react';

const useConvertTime = () => {
  const convertTime = useCallback((timestamp) => {
    const year = timestamp.substring(0, 4);
    const month = timestamp.substring(4, 6) - 1; // JavaScript months are 0-based
    const day = timestamp.substring(6, 8);
    const hourUTC8 = parseInt(timestamp.substring(8, 10), 10);
    const minute = timestamp.substring(10, 12);
    const second = timestamp.substring(12, 14);

    // Convert UTC+8 to EAT (UTC+3)
    const hourEAT = (hourUTC8 - 5 + 24) % 24;

    // Create a proper Date object (YYYY, MM (0-based), DD, HH, MM, SS)
    return new Date(year, month, day, hourEAT, minute, second);
  }, []);

  return convertTime;
};

export default useConvertTime;